module.exports = __webpack_public_path__ + "static/media/Barlow-SemiBold.d8e8ba5e.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/Barlow-SemiBold.ttf
// module id = 703
// module chunks = 0